import React from "react";

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container" style={{ padding: "40px 20px", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6", color: "#333", fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <style>{`
        .privacy-policy-container h1 { font-size: 1.8rem; margin-bottom: 0.5rem; }
        .privacy-policy-container h2 { font-size: 1.25rem; margin-top: 2rem; margin-bottom: 0.75rem; color: #111; }
        .privacy-policy-container p { font-size: 0.95rem; margin-bottom: 1rem; color: #444; }
        .privacy-policy-container ul { font-size: 0.95rem; margin-bottom: 1rem; color: #444; padding-left: 1.5rem; }
        .privacy-policy-container li { margin-bottom: 0.5rem; }
      `}</style>

      <h1 style={{ textAlign: "center" }}>Privacy Policy - CG Land Calc</h1>
      <p style={{ textAlign: "center", color: "#666", marginBottom: "30px", fontSize: "0.85rem" }}>Last Updated: July 16, 2026</p>

      <h2>1. Overview</h2>
      <p>
        CG Land Calc ("the App") is developed and owned by Casagrand ("we," "us," "our") for internal company use only. The App is a land measurement and estimation tool used exclusively by authorized Casagrand employees as part of their job responsibilities. This App is not available to the general public and is not intended for consumer or commercial distribution.
        This Privacy Policy explains what information the App collects, how it is used, and how it is protected.
      </p>

      <h2>2. Who Can Use This App</h2>
      <p>
        Access to CG Land Calc is restricted to employees and authorized personnel of Casagrand. It is not intended for use by the general public, and we do not knowingly collect data from anyone outside our organization.
      </p>

      <h2>3. Information We Collect</h2>
      <p>The App collects the minimum information necessary for employee authentication:</p>
      <ul>
        <li><strong>Account/Login Information</strong> — Employee name, email address, and/or employee ID used solely to authenticate authorized users and grant access to the App.</li>
      </ul>
      <p>We do not collect:</p>
      <ul>
        <li>Location or GPS data</li>
        <li>Device identifiers or device information</li>
        <li>Usage logs or activity/analytics data</li>
        <li>Photos, media, or any camera-captured content</li>
        <li>Financial information, payment details, or any data related to purchases, as the App has no in-app purchases, payments, or subscriptions of any kind</li>
      </ul>
      <p>All land calculations performed within the App are processed using manually entered measurements and are not linked to any location tracking.</p>

      <h2>4. How We Use Information</h2>
      <p>The limited information collected is used solely to:</p>
      <ul>
        <li>Authenticate authorized users</li>
        <li>Grant and manage access to the App</li>
      </ul>
      <p>We do not use any collected data for advertising, marketing, analytics, or any purpose unrelated to login authentication.</p>

      <h2>5. Data Sharing</h2>
      <p>We do not sell, rent, or share your information with third parties for marketing or advertising purposes. Data may only be shared:</p>
      <ul>
        <li>Within Casagrand, with authorized personnel who require access for business purposes</li>
        <li>With service providers (e.g., cloud hosting), strictly to operate the App, under confidentiality obligations</li>
        <li>If required by law or legal process</li>
      </ul>

      <h2>6. Data Storage & Security</h2>
      <p>
        Login information is stored on secure servers with restricted access. We implement reasonable technical and organizational measures to protect data against unauthorized access, alteration, or loss. Access to the App and its data is limited to authorized Casagrand employees.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        Login information is retained only as long as necessary for the employee's employment, or as required by applicable law. Data may be deleted upon employee offboarding or at the company's discretion.
      </p>

      <h2>8. No Third-Party Advertising or Tracking</h2>
      <p>The App does not display third-party advertisements and does not use any tracking or analytics technologies.</p>

      <h2>9. Children's Privacy</h2>
      <p>
        This App is strictly for use by adult employees of Casagrand and is not directed at or intended for use by children under 18 years of age. We do not knowingly collect data from children.
      </p>

      <h2>10. Your Rights</h2>
      <p>
        Employees may contact the company to request access to, correction of, or deletion of their login data collected through the App, subject to company policy and applicable law.
      </p>

      <h2>11. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be reflected with an updated "Last Updated" date on this page.
      </p>

      <h2>12. Contact Us</h2>
      <p>
        For questions or concerns regarding this Privacy Policy or data practices, contact:<br />
        <strong>Casagrand Premier Builder Limited</strong>
      </p>

      <div style={{ marginTop: "40px", textAlign: "center" }}>
        <button
          onClick={() => window.location.href = '/'}
          className="btn btn-primary"
          style={{ padding: "10px 20px" }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
